import React, { useEffect, useState } from "react";
import QuestionBox from "../../QuestionPage/questionbox";
import MCQQuestion from "../../QuestionPage/Mcq";
import ExamPanel from "../ExamPanel";

export default function MultipleTypeSingleMockPage({
  question,
  onInputChange,
  questionNumber,
}) {
  const [originalWords, setOriginalWords] = useState("");
  const [mcqOptions, setMcqOptions] = useState("");
  const [mcqQuestion, setMcqQuestion] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [submitted] = useState(false);

  useEffect(() => {
    setOriginalWords(question?.question || "");
    setMcqOptions(question?.option || []);
    setMcqQuestion(question?.question_mcq || "");
  }, [question]);

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    onInputChange(option);
  };

  return (
    <ExamPanel
      eyebrow="Reading"
      title="Multiple Choice, Single Answer"
      questionLabel={`Question ${questionNumber} of 16`}
      instructions="Read the text and answer the multiple-choice question. Choose one answer only."
    >
      <div className="grid gap-5 xl:grid-cols-[minmax(360px,1fr),minmax(320px,0.85fr)] xl:items-start">
        <QuestionBox
          question={originalWords}
          eyebrow="Reading passage"
          title="Read before choosing an answer"
        />
        <MCQQuestion
          question={mcqQuestion}
          options={mcqOptions}
          onOptionSelect={handleOptionSelect}
          selectedOption={selectedOption}
          submitted={submitted}
        />
      </div>
    </ExamPanel>
  );
}
